<template>
    <select v-if="locations.length > 1" class="tm-select" aria-label="Location"
            :value="modelValue" @change="$emit('update:modelValue', $event.target.value); $emit('change', $event.target.value)">
        <option value="Global">All locations{{ count(global) }}</option>
        <optgroup v-for="g in groups" :key="g.label" :label="g.label">
            <option v-for="l in g.items" :key="l.location" :value="l.location">{{ l.location }}{{ count(l) }}</option>
        </optgroup>
    </select>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { OccupationApiService } from '@/services/OccupationApiService'

// Location filter shared by the catalogue, role details and the career dashboard.
// /api/locations mixes countries and the hub cities inside them; grouped here so it reads.
export default {
    name: 'LocationSelect',
    props: { modelValue: { type: String, default: 'Global' }, showCounts: { type: Boolean, default: false } },
    emits: ['update:modelValue', 'change'],
    setup(props) {
        const locations = ref([])
        onMounted(() => OccupationApiService.Locations().then(res => { locations.value = res.data.locations }).catch(() => {}))
        const global = computed(() => locations.value.find(l => l.kind === 'global'))
        const groups = computed(() => [
            { label: 'Countries', items: locations.value.filter(l => l.kind === 'country') },
            { label: 'Cities', items: locations.value.filter(l => l.kind === 'metro') },
        ].filter(g => g.items.length))
        const count = l => (props.showCounts && l ? ` (${l.postings.toLocaleString()})` : '')
        return { locations, global, groups, count }
    },
}
</script>
